/**
 * URL utility functions for validation and normalization
 */

/**
 * Validates if a URL has the correct format
 * @param {string} url - The URL to validate
 * @returns {boolean} - True if the URL format is valid, false otherwise
 */
export const checkURLFormat = url => {
    const re = /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+([/?].*)?$/gm;
    return re.test(url);
};

/**
 * Normalizes a URL by ensuring it has the https:// protocol
 * @param {string} url - The URL to normalize
 * @returns {string} - The normalized URL with https:// protocol
 */
export const normalizeURL = url => {
    if (!url.startsWith('https://')) {
        return 'https://' + url.replace(/^(https?:\/\/)/, '');
    }
    return url.trim();
};

/**
 * Validates and normalizes a URL
 * @param {string} url - The URL to validate and normalize
 * @returns {object} - Object containing isValid boolean and normalized URL
 */
export const validateAndNormalizeURL = url => {
    const normalizedUrl = normalizeURL(url);
    const isValid = checkURLFormat(normalizedUrl);

    return {
        isValid,
        normalizedUrl: isValid ? normalizedUrl.replace(/\/$/, '') : url
    };
}; 